import { gql } from "@apollo/client";
import { SnowflakeOAuthConnectionId } from "@hex/common";
import React, { useCallback } from "react";

import { OAuthSuccessView } from "./OAuthSuccessView.js";
import {
  useFetchSnowflakeAccessTokenForSuccessViewMutation,
  useGetSnowflakeOAuthConnectionByIdLazyQuery,
} from "./SnowflakeOauthSuccessView.generated";

gql`
  mutation FetchSnowflakeAccessTokenForSuccessView(
    $code: String!
    $state: String!
  ) {
    fetchSnowflakeAccessToken(code: $code, state: $state) {
      id
      linkedDataConnections {
        id
      }
    }
  }
`;

gql`
  query GetSnowflakeOAuthConnectionById(
    $snowflakeOAuthConnectionId: SnowflakeOAuthConnectionId!
  ) {
    getSnowflakeOAuthConnectionById(
      snowflakeOAuthConnectionId: $snowflakeOAuthConnectionId
    ) {
      id
      linkedDataConnections {
        id
      }
    }
  }
`;

export const SnowflakeOauthSuccessView: React.ComponentType = React.memo(
  function SnowflakeOauthSuccessView() {
    const [fetchSnowflakeAccessTokenMutation] =
      useFetchSnowflakeAccessTokenForSuccessViewMutation();
    const [getSnowflakeOAuthConnectionByIdQuery] =
      useGetSnowflakeOAuthConnectionByIdLazyQuery();

    const fetchAccessToken = useCallback(
      async ({
        variables,
      }: {
        variables: {
          code: string;
          state: string;
        };
      }) => {
        const { data, errors } = await fetchSnowflakeAccessTokenMutation({
          variables,
        });

        return {
          linkedDataConnectionIds:
            data?.fetchSnowflakeAccessToken.linkedDataConnections.map(
              ({ id }) => id,
            ),
          errors: errors,
        };
      },
      [fetchSnowflakeAccessTokenMutation],
    );

    const getLinkedDataConnectionIds = useCallback(
      async ({ oAuthConnectionId }: { oAuthConnectionId: string }) => {
        const { data } = await getSnowflakeOAuthConnectionByIdQuery({
          variables: {
            snowflakeOAuthConnectionId:
              oAuthConnectionId as SnowflakeOAuthConnectionId,
          },
        });
        return (
          data?.getSnowflakeOAuthConnectionById.linkedDataConnections.map(
            ({ id }) => id,
          ) ?? []
        );
      },
      [getSnowflakeOAuthConnectionByIdQuery],
    );

    return (
      <OAuthSuccessView
        broadcastChannel="snowflake-oauth"
        fetchAccessToken={fetchAccessToken}
        getLinkedDataConnectionIds={getLinkedDataConnectionIds}
      />
    );
  },
);
